// Chinese (Simplified) translations
const zh = {
  cover: {
    title: "国际象棋王国",
    subtitle: "国王的宫廷",
    riseOfDukes: "公爵的崛起",
    enter: "进入",
    aboutUs: "关于我们",
    tagline: "传奇诞生之地，每一步棋都诉说着故事",
    selectLanguage: "选择语言"
  },
  auth: {
    login: "登录",
    register: "注册",
    email: "电子邮箱",
    password: "密码",
    confirmPassword: "确认密码",
    username: "用户名",
    forgotPassword: "忘记密码？",
    noAccount: "没有账户？",
    hasAccount: "已有账户？",
    signUp: "注册",
    signIn: "登录",
    orContinueWith: "或继续使用",
    guest: "游客模式",
    logout: "退出"
  },
  lobby: {
    title: "大厅",
    subtitleRise: "公爵的",
    subtitleDukes: "崛起",
    quickPlay: "快速游戏",
    createRoom: "创建房间",
    joinRoom: "加入房间",
    settings: "设置",
    skins: "皮肤",
    friends: "好友",
    chat: "聊天",
    spectate: "观战",
    roomCode: "房间代码",
    enterRoomCode: "输入代码...",
    join: "加入",
    create: "创建",
    private: "私人",
    public: "公开",
    players: "玩家",
    waiting: "等待对手...",
    ready: "准备",
    start: "开始",
    gameSetup: "游戏设置",
    chooseVariant: "选择变体和模式",
    multiplayer: "多人游戏",
    onlineMatches: "在线对局",
    profile: "个人资料",
    messages: "消息",
    assistant: "助手",
    help: "帮助",
    exit: "退出"
  },
  game: {
    white: "白方",
    black: "黑方",
    whiteToMove: "白方走棋",
    blackToMove: "黑方走棋",
    check: "将军！",
    checkmate: "将死！",
    stalemate: "和棋！",
    draw: "和棋",
    resign: "认输",
    resigns: "认输",
    forfeits: "弃权",
    offerDraw: "提议和棋",
    acceptDraw: "接受和棋",
    declineDraw: "拒绝和棋",
    newGame: "新游戏",
    leave: "离开",
    rules: "规则",
    moveHistory: "走棋历史",
    noMovesYet: "暂无走棋",
    movesWillAppear: "走棋记录将显示在此",
    yourTurn: "你的回合",
    opponentTurn: "对手回合",
    gameOver: "游戏结束",
    youWin: "你赢了！",
    youLose: "你输了",
    whiteWins: "白方获胜！",
    blackWins: "黑方获胜！",
    drawGame: "平局！",
    playAgain: "再来一局",
    backToLobby: "返回大厅",
    classic: "经典",
    kingsCourt: "王者之庭",
    fightToBeKing: "争夺王位",
    kingCaptured: "国王被擒！",
    winner: "获胜者",
    rematch: "重赛",
    decline: "拒绝",
    waiting: "等待中...",
    acceptRematch: "接受重赛",
    wantsRematch: "请求重赛！",
    rematchAccepted: "重赛已接受！开始新游戏...",
    rematchDeclined: "重赛被拒绝。返回大厅...",
    waitingForOpponent: "等待对手...",
    startingNewGame: "开始新游戏...",
    continue: "继续"
  },
  settings: {
    title: "设置",
    boardCustomization: "棋盘和棋子自定义",
    livePreview: "实时预览",
    previewDescription: "查看您的自定义效果",
    boardTheme: "棋盘颜色",
    pieceTheme: "棋子颜色",
    customColors: "自定义颜色",
    presetThemes: "预设主题",
    lightSquares: "浅色格子",
    darkSquares: "深色格子",
    whitePieces: "白方棋子",
    blackPieces: "黑方棋子",
    coordinateColor: "坐标颜色",
    coordinateDescription: "自定义数字(1-8)和字母(a-h)的颜色",
    chessPieceSkins: "棋子皮肤",
    chessPieceSkinsDescription: "用高级3D皮肤替换标准棋子",
    dukeSkins: "公爵皮肤",
    dukeSkinsDescription: "选择公爵皮肤 - 棋盘颜色自动匹配！",
    whiteSideDuke: "白方公爵",
    blackSideDuke: "黑方公爵",
    autoMatchBoard: "自动匹配棋盘颜色",
    saveAndClose: "保存并关闭",
    reset: "重置默认",
    close: "关闭",
    premium: "高级",
    default: "默认",
    classic: "经典",
    viewMode: "视图模式",
    viewModeDescription: "选择棋盘视图",
    topDown: "俯视图",
    topDownDescription: "传统平面视图",
    perspective3D: "3D透视",
    perspective3DDescription: "动态3D角度的2D棋子",
    skinsApplyTo: "皮肤适用于王、后、车、象、马、兵",
    dukeHint: "左：即时称王 · 右：争夺王位"
  },
  store: {
    title: "皮肤商店",
    subtitle: "国王的宫廷",
    riseOfDukes: "公爵的崛起",
    chessPieces: "国际象棋棋子",
    dukeSkins: "公爵皮肤",
    allPiecesBundle: "全套棋子皮肤包",
    allDukeBundle: "全套公爵皮肤包",
    bundleDiscount: "所有高级皮肤7折优惠！",
    owned: "已拥有",
    equip: "装备",
    buy: "购买",
    processing: "处理中...",
    free: "免费",
    rare: "稀有",
    epic: "史诗",
    legendary: "传奇",
    common: "普通",
    securePayment: "一次购买 • 永久使用 • 安全支付"
  },
  chat: {
    title: "聊天",
    lobbyChat: "大厅聊天",
    gameChat: "游戏聊天",
    typeMessage: "输入消息...",
    send: "发送",
    spectatorChat: "观众聊天",
    playerChat: "玩家聊天"
  },
  friends: {
    title: "好友",
    online: "在线",
    offline: "离线",
    addFriend: "添加好友",
    removeFriend: "删除",
    invite: "邀请",
    pending: "待处理",
    accept: "接受",
    decline: "拒绝",
    friendRequests: "好友请求",
    noFriends: "暂无好友",
    searchPlayers: "搜索玩家..."
  },
  notifications: {
    friendRequest: "向您发送了好友请求",
    gameInvite: "邀请您对局",
    yourTurn: "轮到你了！",
    opponentJoined: "对手已加入",
    opponentLeft: "对手已离开",
    drawOffered: "对手提议和棋",
    connected: "已连接服务器",
    disconnected: "已断开连接",
    reconnecting: "重新连接中..."
  },
  errors: {
    invalidEmail: "无效的邮箱地址",
    invalidPassword: "密码至少需要6个字符",
    passwordMismatch: "密码不匹配",
    loginFailed: "登录失败，请检查您的凭据",
    registerFailed: "注册失败，请重试",
    connectionError: "连接错误，请重试",
    connectionErrorInternet: "连接错误，请检查您的网络",
    gameNotFound: "未找到游戏",
    roomFull: "房间已满",
    invalidMove: "无效走棋",
    pleaseEnterName: "请输入您的名字",
    completeBothSecurityQuestions: "请完成两个安全问题或全部留空",
    selectDifferentQuestions: "请选择不同的问题",
    unexpectedError: "发生意外错误",
    failedToSendResetCode: "发送重置码失败",
    invalidOrExpiredCode: "无效或过期的代码",
    failedToResetPassword: "重置密码失败，请重试",
    pleaseEnterRoomName: "请输入房间名称",
    pleaseEnterRoomCode: "请输入房间代码",
    roomCodeMustBe6Chars: "代码必须是6个字符",
    roomNotFound: "房间未找到，请检查代码",
    roomRequiresApproval: "此房间需要批准，请从列表申请",
    failedToCreateRoom: "创建房间失败",
    failedToJoinRoom: "加入房间失败",
    failedToLeaveRoom: "离开房间失败",
    failedToRemoveRoom: "删除房间失败",
    failedToLoadGames: "加载游戏失败",
    failedToRequestRejoin: "重新加入请求失败",
    failedToJoinMatchmaking: "加入匹配失败",
    noOpponentFound: "未找到对手，请稍后重试",
    searchFailed: "搜索失败",
    failedToSendRequest: "发送请求失败",
    failedToAcceptRequest: "接受请求失败",
    failedToRejectRequest: "拒绝请求失败",
    failedToCancelRequest: "取消请求失败",
    failedToRemoveFriend: "删除好友失败"
  },
  success: {
    copiedToClipboard: "已复制到剪贴板！",
    rejoinRequestSent: "已向房主发送请求！",
    roomRemovedFromList: "房间已从列表中移除",
    leftRoomSuccessfully: "已成功离开房间",
    requestRejected: "请求已拒绝",
    requestCancelled: "请求已取消",
    friendRemoved: "好友已删除",
    tournamentCreated: "锦标赛创建成功！",
    tournamentJoined: "成功加入锦标赛！",
    tournamentLeft: "已离开锦标赛",
    tournamentStarted: "锦标赛已开始！",
    tournamentCancelled: "锦标赛已取消",
    tournamentsCleared: "所有锦标赛已清除",
    removedFromHistory: "已从历史记录中移除"
  },
  tournament: {
    title: "锦标赛",
    createTournament: "创建锦标赛",
    joinTournament: "加入锦标赛",
    leaveTournament: "离开锦标赛",
    startTournament: "开始锦标赛",
    cancelTournament: "取消锦标赛",
    clearAll: "清除全部",
    myTournaments: "我的锦标赛",
    availableTournaments: "可用锦标赛",
    tournamentHistory: "锦标赛历史",
    bracket: "对阵表",
    participants: "参与者",
    status: "状态",
    waiting: "等待中",
    inProgress: "进行中",
    completed: "已完成",
    cancelled: "已取消",
    format: "赛制",
    singleElimination: "单败淘汰",
    doubleElimination: "双败淘汰",
    swiss: "瑞士制",
    round: "轮次",
    match: "比赛",
    ready: "准备就绪",
    notReady: "未准备",
    markReady: "标记准备",
    winner: "获胜者",
    loser: "失败者",
    bye: "轮空",
    pleaseLoginToCreate: "请登录以创建锦标赛",
    pleaseLoginToJoin: "请登录以加入锦标赛",
    failedToLoadTournaments: "加载锦标赛失败",
    failedToCreateTournament: "创建锦标赛失败",
    failedToJoinTournament: "加入锦标赛失败",
    failedToLeaveTournament: "离开锦标赛失败",
    failedToStartTournament: "开始锦标赛失败",
    failedToCancelTournament: "取消锦标赛失败",
    failedToClearTournaments: "清除锦标赛失败",
    failedToRemoveFromHistory: "从历史记录中移除失败",
    failedToLoadTournament: "加载锦标赛失败",
    failedToMarkReady: "标记准备失败"
  },
  ranked: {
    title: "排位赛",
    findMatch: "寻找排位赛",
    inQueue: "排队中...",
    leaveQueue: "离开队列",
    yourRank: "您的排名",
    elo: "ELO",
    tier: "段位",
    wins: "胜场",
    losses: "败场",
    draws: "平局",
    season: "赛季",
    leaderboard: "排行榜",
    squire: "侍从",
    knight: "骑士",
    baron: "男爵",
    duke: "公爵",
    king: "国王",
    pleaseLoginToPlay: "请登录以进行排位赛",
    failedToJoinQueue: "加入队列失败"
  },
  misc: {
    loading: "加载中...",
    cancel: "取消",
    confirm: "确认",
    yes: "是",
    no: "否",
    ok: "确定",
    save: "保存",
    delete: "删除",
    edit: "编辑",
    back: "返回",
    next: "下一步",
    previous: "上一步",
    search: "搜索",
    filter: "筛选",
    sort: "排序",
    all: "全部",
    none: "无",
    select: "选择",
    selected: "已选择"
  },
  
  // About Us Page
  aboutUs: {
    back: "← 返回",
    title: "欢迎来到Chess Kingdom: 国王法庭",
    subtitle: "国王的宫廷",
    riseOfDukes: "公爵的崛起",
    description: "进入一个经典策略与神话规模相遇的王国。国王法庭不仅仅是一个游戏模式——它是战术家、梦想家和冠军的试炼场。无论你是寻求新挑战的大师，还是被征服快感吸引的新手，这里是你的竞技场。⚔️",
    keyFeatures: "主要特点",
    feature1Title: "动态变体",
    feature1Desc: "探索不断演变的规则集和棋盘布局，测试你的适应能力和远见。",
    feature2Title: "宫廷晋升",
    feature2Desc: "赢得头衔，解锁徽章，在丰富的排名系统中晋升，奖励精通和风格。",
    feature3Title: "技能为本",
    feature3Desc: "透明反馈、遥测调整平衡和公平匹配确保每场胜利都是实至名归。",
    feature4Title: "实时聊天与故事",
    feature4Desc: "与对手和盟友联系，发现程序生成的故事，塑造你王国的神话。",
    feature5Title: "为专业玩家打造",
    feature5Desc: "精确调优、回放分析和锦标赛级基础设施使国王法庭成为竞技游戏的严肃平台。",
    closingStatement: "无论你追求荣耀、成长还是宏大战略，国王法庭邀请你以智慧统治，以荣誉战斗，在王国中留下你的印记。",
    developmentNotice: "注意：游戏仍在开发中，有了您的耐心和支持，游戏将成为远离家乡的家。享受乐趣，结交朋友和联盟，因为当我完成时，你的战略制胜方法将受到考验...欢迎来到你的王国...",
    contactTitle: "更多信息或建议联系：",
    contactEmail: "CKKC.customerservice@gmail.com"
  },
  
  // Store
  store: {
    title: "皮肤商店",
    themedSets: "主题套装",
    pieceSkins: "棋子皮肤",
    dukeSkins: "公爵皮肤",
    unlockSet: "解锁套装",
    owned: "已拥有",
    price: "价格",
    checkout: "结账",
    addToCart: "加入购物车",
    cart: "购物车",
    total: "总计",
    continueShopping: "继续购物",
    proceedToCheckout: "前往结账",
    emptyCart: "您的购物车是空的",
    itemAdded: "商品已加入购物车",
    purchaseSuccess: "购买成功！",
    purchaseFailed: "购买失败，请重试。"
  },
  
  // Rules
  rules: {
    title: "游戏规则",
    classic: "经典国际象棋",
    classicDesc: "标准国际象棋规则 - 将对方国王将死即可获胜。",
    instantKing: "即刻国王",
    instantKingDesc: "直接吃掉敌方国王即可获胜 - 不需要将死！",
    fightToBeKing: "争夺王位",
    fightToBeKingDesc: "你的升变兵成为新国王！保护它否则输掉游戏。",
    timerRules: "计时规则",
    timerDesc: "每位玩家每步有限时。时间用完，你的回合将被跳过。"
  },
  
  // Assistant
  assistant: {
    title: "Chess Kingdom助手",
    searchPlaceholder: "搜索帮助主题...",
    randomTip: "显示随机提示",
    noResults: "未找到相关帮助主题",
    noResultsHint: "尝试其他关键词或浏览上方分类",
    categories: {
      gettingStarted: "入门",
      dukeMechanics: "公爵机制",
      multiplayer: "多人游戏",
      customization: "自定义",
      boardFeatures: "棋盘功能",
      skinStore: "皮肤商店",
      trialPayments: "试用与付款",
      strategyTips: "战略技巧",
      troubleshooting: "故障排除"
    },
    gettingStarted: {
      q1: "如何开始游戏？",
      a1: "点击'单人游戏'与AI对战，或'多人游戏'与其他玩家对战。您可以作为访客游戏，或注册获得48小时免费试用。",
      q2: "有哪些游戏变体？",
      a2: "Chess Kingdom提供7种变体：标准国际象棋、即刻国王、争夺王位、玩家选择、狂野兵、Chess Kingdom（双公爵）和让子模式。",
      q3: "如何自定义棋盘？",
      a3: "点击设置按钮访问自定义选项。您可以更改棋盘颜色、棋子皮肤、公爵皮肤、主题、坐标颜色、视图模式和棋盘大小。",
      q4: "如何翻转棋盘视图？",
      a4: "点击游戏标题中的翻转按钮，从黑方视角查看棋盘。",
      q5: "如何调整棋盘大小？",
      a5: "前往设置 → 棋盘大小。使用滑块或点击'紧凑'(85%)、'默认'(100%)或'大'(115%)。"
    },
    dukeMechanics: {
      q1: "什么是公爵棋子？",
      a1: "公爵是替代象的特殊棋子。非吃子时斜走1格，但可以向8个方向吃子（仅限相邻格）。",
      q2: "当我的王被吃掉会发生什么？",
      a2: "您的公爵会变成新的王！变换规则取决于模式：即刻国王或争夺王位。",
      q3: "争夺王位如何运作？",
      a3: "王被吃掉后，您的公爵必须返回起始线（白方第1行，黑方第8行）才能变成王。",
      q4: "公爵棋子可以升变吗？",
      a4: "只有在狂野兵变体中可以！当兵到达底线时，您可以升变为后、车、象、马或公爵。",
      q5: "即刻国王和争夺王位皮肤有什么区别？",
      a5: "公爵皮肤有两个版本：'即刻国王'版本在正常游戏中出现，而'争夺王位'在公爵争取到达底线时出现。"
    },
    multiplayer: {
      q1: "快速匹配如何工作？",
      a1: "快速匹配立即为您配对另一位玩家！选择您喜欢的游戏模式，点击'寻找对局'，您将与选择相同模式的人配对。",
      q2: "如何创建和管理私人房间？",
      a2: "前往'创建房间'标签，输入房间名称，选择变体，设置观众设置，并与朋友分享6位代码。",
      q3: "如何加入朋友的房间？",
      a3: "前往'加入房间'标签，输入朋友分享的6位代码，点击'加入'。",
      q4: "观众设置有哪些？",
      a4: "私人：无观众。请求加入：观众必须请求批准。开放：任何人都可以自由观看。",
      q5: "如何作为观众观看游戏？",
      a5: "前往'观看'标签查看所有公开游戏。按游戏类型筛选以找到特定变体。",
      q6: "游戏中可以聊天吗？",
      a6: "可以！在多人游戏中使用游戏内聊天。如果玩家说不同语言，消息会自动翻译！",
      q7: "我的主题会与对手同步吗？",
      a7: "会！如果您是房主，您的棋盘主题、棋子皮肤和公爵皮肤会自动与所有玩家同步。"
    },
    customization: {
      q1: "有哪些棋子皮肤？",
      a1: "我们有20多套：金色3D、黑曜石3D、复古、卡哇伊、寓言、哥特、巨人、紫水晶、蓝宝石、石沙王国等！",
      q2: "有哪些公爵皮肤？",
      a2: "50多种皮肤分类：金属（金、银）、彩色（紫、蓝、翡翠）、白色（斯巴达、鹰）、黑色（钢、冠）、宝石、王国、3D高级等！",
      q3: "如何更改棋子皮肤？",
      a3: "设置 → 棋子皮肤。您可以为白方和黑方分别设置不同的皮肤！使用'双方预览'查看效果。",
      q4: "如何更改公爵皮肤？",
      a4: "设置 → 公爵皮肤。选择按白、黑或中性分类的皮肤。每个公爵都有即刻国王和争夺王位版本。",
      q5: "什么是主题包？",
      a5: "主题包将棋子皮肤、公爵皮肤和棋盘主题捆绑在一起！可用包：皇家金、暗黑骑士、复古经典和王国之战包！",
      q6: "如何获取随机主题？",
      a6: "点击'随机主题包'应用随机完整主题，或'随机王国之战'进行随机阵营对决。",
      q7: "可以自定义坐标颜色吗？",
      a7: "可以！设置 → 坐标颜色。为行号(1-8)和列字母(a-h)选择任意颜色。"
    },
    boardFeatures: {
      q1: "有哪些视图模式？",
      a1: "两种模式：3D透视（带深度和阴影）和俯视图（平面、传统）。在设置 → 视图模式中切换。",
      q2: "棋盘大小调整如何工作？",
      a2: "设置 → 棋盘大小可以从80%（紧凑）缩放到120%（大）。默认100%。",
      q3: "有哪些棋盘主题？",
      a3: "多种颜色主题：经典木纹、皇家金、暗黑骑士、海洋蓝、森林绿、石灰等。",
      q4: "坐标如何工作？",
      a4: "坐标在棋盘边缘显示行号(1-8)和列字母(a-h)。使用翻转按钮时它们会正确翻转！",
      q5: "棋盘在移动设备上能用吗？",
      a5: "能！棋盘完全响应式。在横屏模式下，棋盘会自动调整以适应屏幕高度。"
    },
    skinStore: {
      q1: "如何访问皮肤商店？",
      a1: "从大厅点击商店按钮，或通过设置 →'访问商店'按钮。商店有三个标签：主题套装、棋子皮肤和公爵皮肤。",
      q2: "什么是主题套装？",
      a2: "折扣完整主题包！包括配套的棋子皮肤、公爵皮肤和棋盘主题。",
      q3: "有捆绑折扣吗？",
      a3: "有！'全棋子皮肤包'和'全公爵皮肤包'可以40%折扣获得所有皮肤。",
      q4: "皮肤稀有度如何运作？",
      a4: "普通（灰）：免费或基础。稀有（蓝）：¥12-18。史诗（紫）：¥18-28。传奇（金）：¥25-35。",
      q5: "购买前可以预览吗？",
      a5: "可以！将鼠标悬停在任何皮肤卡上查看预览。棋子皮肤显示王、后和马。",
      q6: "如何装备已购买的皮肤？",
      a6: "在商店中，您拥有的皮肤显示'装备'按钮而不是价格。点击装备立即应用。"
    },
    trialPayments: {
      q1: "什么是48小时免费试用？",
      a1: "新用户获得48小时免费访问所有变体。试用结束后，标准国际象棋和即刻国王保持免费。",
      q2: "变体价格是多少？",
      a2: "争夺王位和让子模式：¥20，玩家选择：¥28，狂野兵和双公爵：¥35。或获取全变体包¥60！",
      q3: "皮肤价格是多少？",
      a3: "单个皮肤：¥12-35取决于稀有度。捆绑包：约40%折扣。主题套装：¥60-90。",
      q4: "可以作为访客游戏吗？",
      a4: "可以！访客模式允许立即游戏无需注册。但游戏历史不会保存。",
      q5: "支付如何工作？",
      a5: "所有支付通过Stripe安全处理。一次性购买永久解锁内容。无需订阅。"
    },
    strategyTips: {
      q1: "公爵开局策略？",
      a1: "早期将公爵定位于控制中心对角线。其独特的8方向吃子能力使其非常适合威胁多个棋子。",
      q2: "何时选择即刻国王vs争夺王位？",
      a2: "如果公爵位置好选择即刻国王。如果公爵已经靠近底线选择争夺王位。",
      q3: "双公爵变体策略？",
      a3: "小心保护两个公爵 - 它们是您的'额外生命'！当王被吃掉时，选择更安全的公爵进行变换。",
      q4: "狂野兵残局？",
      a4: "考虑将兵升变为公爵作为'王保险' - 如果您的王后来被吃掉，升变的公爵可以成为新王！",
      q5: "战略性使用棋盘翻转？",
      a5: "翻转棋盘从对手视角查看局面！这有助于发现您可能遗漏的威胁。"
    },
    troubleshooting: {
      q1: "游戏加载缓慢",
      a1: "尝试故障排除按钮运行诊断。检查网络连接。尝试刷新页面（Ctrl+F5）。",
      q2: "多人游戏无法连接",
      a2: "使用故障排除检查WebSocket连接状态。确保已登录。检查防火墙/VPN问题。",
      q3: "设置不保存",
      a3: "设置使用localStorage。检查浏览器是否允许。尝试故障排除中的'重置设置'选项。",
      q4: "走棋历史在哪里？",
      a4: "走棋历史侧边栏在游戏进行中显示在右侧。需要浏览器宽度>768px。",
      q5: "棋盘大小滑块不工作？",
      a5: "尝试：1）刷新页面。2）清除浏览器缓存。3）检查是否在游戏中。4）尝试不同的视图模式。",
      q6: "棋子看起来太小/太大？",
      a6: "不同棋子皮肤有不同最佳尺寸。前往设置 → 棋盘大小进行调整。",
      q7: "忘记密码？",
      a7: "前往账户页面 →'忘记密码？'→ 回答安全问题 → 密码发送到邮箱。",
      q8: "如何联系支持？",
      a8: "技术问题使用故障排除。账单/账户问题从账户页面发送邮件。"
    },
    tips: {
      tip1: "公爵可以向8个方向吃子，但不吃子时只能斜走！",
      tip2: "在争夺王位模式中，公爵必须到达底线才能变换。",
      tip3: "将公爵定位于控制多个格子 - 其独特移动非常强大！",
      tip4: "在双公爵变体中，保护两个公爵给您更多翻盘选择。",
      tip5: "在狂野兵中，升变为公爵在被吃时提供'王保险'。",
      tip6: "快速匹配：选择与对手相同的游戏模式即可立即配对！",
      tip7: "创建的房间显示在'我的房间'，加入的显示在'已加入房间'。",
      tip8: "将房间设为'开放'让任何人观看您的精彩对局！",
      tip9: "请求模式：玩家必须批准观众 - 非常适合私人教学。",
      tip10: "最多可创建5个房间。取消或完成以创建更多。",
      tip11: "点击设置随时更改棋盘和棋子颜色。",
      tip12: "所有走棋都记录在屏幕右侧的侧边栏中。",
      tip13: "为说不同语言的玩家自动翻译消息！",
      tip14: "每个私人房间获得唯一的6位代码与朋友分享。",
      tip15: "主题包：一键获得配套的棋子、公爵和棋盘主题！",
      tip16: "尝试石沙vs林地战士进行史诗阵营战争！",
      tip17: "让游戏为您选择随机主题 - 发现新收藏！",
      tip18: "紫水晶和蓝宝石让您的棋子闪闪发光！",
      tip19: "点击翻转按钮从黑方视角查看 - 非常适合分析！",
      tip20: "在移动设备上旋转以获得更大的棋盘视图！",
      tip21: "使用设置中的滑块将棋盘从80%缩放到120%！",
      tip22: "巨人套装展示史诗级大理石和青铜雕刻棋子！",
      tip23: "四套可爱的卡哇伊表情棋子 - 棕、白、黑、米色！",
      tip24: "哥特白和黑套装展示精致的暗黑幻想设计！",
      tip25: "寓言中世纪：十字军骑士vs暗黑战士 - 史诗战斗棋子！"
    }
  },

  // Account Manager
  account: {
    title: "账户管理",
    accountInfo: "账户信息",
    usernameEmail: "用户名/邮箱",
    displayName: "显示名称",
    accountType: "账户类型",
    userId: "用户ID",
    guest: "访客",
    registered: "已注册",
    notAvailable: "不可用",
    notificationSettings: "通知设置",
    notificationSound: "通知声音",
    notificationSoundDesc: "收到通知时播放声音",
    security: "安全",
    passwordManagement: "密码管理",
    passwordNote: "出于安全原因，我们不显示密码。如需重置密码，请使用'忘记密码'功能。",
    forgotPassword: "忘记密码？",
    passwordRecovery: "密码恢复",
    passwordRecoveryHelp: "回答安全问题以通过邮箱接收密码",
    securityQuestion1: "安全问题1",
    securityQuestion2: "安全问题2",
    selectQuestion: "选择问题...",
    yourAnswer: "您的答案",
    sendPasswordEmail: "发送密码到邮箱",
    securityQuestions: {
      q1: "您第一只宠物叫什么名字？",
      q2: "您出生在哪个城市？",
      q3: "您母亲的娘家姓是什么？",
      q4: "您的小学叫什么名字？",
      q5: "您最喜欢的书是什么？",
      q6: "您童年的昵称是什么？",
      q7: "您最喜欢的老师叫什么名字？",
      q8: "您在哪条街上长大？"
    },
    dangerZone: "危险区域",
    deleteAccount: "删除账户",
    deleteAccountDesc: "永久删除您的账户和所有相关数据。",
    deleteWarning: "这将永久删除：",
    deleteWarningItems: {
      account: "您的账户和个人资料",
      gameHistory: "所有游戏历史",
      friends: "好友连接",
      purchases: "已购买的变体",
      settings: "设置和偏好"
    },
    typeDelete: "输入DELETE确认：",
    typeDeletePlaceholder: "在此输入DELETE",
    deleteForever: "永久删除我的账户",
    deleteConfirmMsg: "此操作无法撤销。",
    deleteSuccess: "账户删除成功。您将被登出。",
    deleteFailed: "删除账户失败",
    passwordResetSuccess: "密码重置成功！您的密码已发送到邮箱。请检查收件箱（和垃圾邮件文件夹）。",
    securityAnswersIncorrect: "安全答案不正确。请重试。",
    passwordResetFailed: "密码重置失败。请重试。",
    answerBothQuestions: "请回答两个安全问题"
  }
};

export default zh;
